<template>
    <div class="p-3">
        <h2 class="mb-5">Add Product Category</h2>
        <ElementCategories category_id="7" elementName="Product"></ElementCategories>
    </div>
</template>

<script>
import ElementCategories from "@/components/ElementComponents/ElementCategories";

export default {
    components: {
        ElementCategories,
    },
    methods: {},
};
</script>
